import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children, requireAuth = true }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  // console.log('ProtectedRoute check:', { 
  //   requireAuth, 
  //   isAuthenticated, 
  //   loading, 
  //   user: user ? user.email : null,
  //   currentPath: location.pathname 
  // });

  // Show loading spinner while checking auth status
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full"></div>
          <p className="text-gray-300">Memverifikasi akses...</p>
        </div>
      </div>
    );
  }

  // If route requires authentication but user is not authenticated
  if (requireAuth && !isAuthenticated) {
    // console.log('Redirecting to login - user not authenticated');
    return (
      <Navigate 
        to="/login" 
        state={{ 
          from: location.pathname,
          redirectAfterLogin: location.pathname 
        }} 
        replace 
      />
    );
  }

  // If route requires no authentication (public routes for non-authenticated users)
  if (!requireAuth && isAuthenticated) {
    // Only redirect from login/register pages when user is already authenticated
    if (location.pathname === '/login' || location.pathname === '/register') {
      // console.log('Redirecting authenticated user from auth pages to dashboard');
      const redirectTo = location.state?.from || '/dashboard';
      return <Navigate to={redirectTo} replace />;
    }
  }

  // FIXED: Always render children if user has proper access
  // This covers all scenarios:
  // - requireAuth=true && isAuthenticated=true (authenticated user accessing protected route)
  // - requireAuth=false && isAuthenticated=false (non-authenticated user accessing public route) 
  // - requireAuth=false && isAuthenticated=true (authenticated user accessing public route - except login/register)
  // console.log('Rendering content');
  return children;
};

// Alternative component for more explicit control
export const PublicRoute = ({ children }) => {
  return <ProtectedRoute requireAuth={false}>{children}</ProtectedRoute>;
};

export const PrivateRoute = ({ children }) => {
  return <ProtectedRoute requireAuth={true}>{children}</ProtectedRoute>;
};

export default ProtectedRoute;